import { AfterViewInit, ChangeDetectorRef, Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatBottomSheet } from '@angular/material';
import { RouterOutlet } from '@angular/router';
import { BottomSheetComponent } from './components/bottom-sheet/bottom-sheet.component';
import { routerTransition } from './router.animations';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'app-root'
    },
    animations: [routerTransition],
})
export class AppComponent implements AfterViewInit {
    title = 'navigation-rottalschau';

    // @ts-ignore
    @ViewChild('routerOutlet')
    routerOutlet: RouterOutlet;

    transitionName: string;

    private previousPath = '';


    constructor(private _bottomSheet: MatBottomSheet, private _changeDetector: ChangeDetectorRef) {
    }

    ngAfterViewInit() {
        this.routerOutlet.activateEvents.subscribe(() => {
            this.transitionName = this.getPageTransition(this.routerOutlet);
            this._changeDetector.detectChanges();
        });
    }

    openBottomSheet(): void {
        this._bottomSheet.open(BottomSheetComponent);
    }

    getPageTransition(routerOutlet: RouterOutlet) {
        if (routerOutlet.isActivated) {
            let transitionName = 'section';

            const {path} = routerOutlet.activatedRoute.routeConfig;
            const isSame = this.previousPath === path;

            const isBackward = this.previousPath.startsWith(path);
            const isForward = path.startsWith(this.previousPath);

            if (isSame) {
                transitionName = 'none';
            } else if ('navigation' === path) {
                transitionName = 'forward';
            } else if ('exhibitor' === path) {
                transitionName = 'backward';
            } else {
                transitionName = 'section';
            }

            this.previousPath = path;

            return transitionName;
        }

        return 'none';
    }
}


